import React, { Component } from "react";
import "../../src/Styles/Pages/submenu.scss";

class SubMenu extends Component {
  constructor(props) {
    super(props);
    this.content = React.createRef();
    this.state = {
      top: 0,
      hasEnoughSpaceToShowSubMenu: true,
    };
  }

  captureClick = (e) => {
    if (this.content.current) {
      if (this.content.current.contains(e.target)) {
        return;
      }
      this.props.close();
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.captureClick, false);
    this.setState({
      top: this.content.current.getBoundingClientRect().height + 30,
    });

    if (
      window.screen.height -
        this.content.current.getBoundingClientRect().bottom <
      100
    ) {
      this.setState({ hasEnoughSpaceToShowSubMenu: false });
    } else {
      this.setState({ hasEnoughSpaceToShowSubMenu: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.captureClick, false);
  }
  render() {
    let left = this.props.target
      ? this.props.target.getBoundingClientRect().x
      : "";
    let top = this.props.target
      ? this.props.target.getBoundingClientRect().y
      : "";
    let height = this.props.target
      ? this.props.target.getBoundingClientRect().height
      : 0;

    if (this.props.addTargetDimension) {
      top = top + height / 2.5;
      left = left - this.props.target.getBoundingClientRect().width;
    } else {
      if (this.state.hasEnoughSpaceToShowSubMenu) {
        if (this.props.position && top && window.screen.height - top > 150) {
          top = top - this.state.top;
        }
      } else {
        top = top - (this.content.current.getBoundingClientRect().height + 30);
      }

      if (!this.props.position) {
        left = left - 120;
      }
    }

    return (
      <div className="bo-submenu">
        <div
          className="bo-submenu-body"
          ref={this.content}
          onClick={() => this.props.close()}
          style={{
            width: `${this.props.width}px` || "150px",
            top: top + 20 || "",
            left: left,
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default SubMenu;
